import { App } from 'vue'
import '../style/index.scss'
import KButton from './button'
import KInput from './input'
import KIcon from './icon'
import KJsonEdit from './json-edit'
import KJsonParse, {getBasicLayout, registerLayout, disposeConfig} from './json-parse'

interface IInstallOptions {
  [prop: string]: any
}

const components = [KButton, KIcon, KJsonParse, KJsonEdit, KInput]

const install = (app: App, options: IInstallOptions = {}): void => {
  components.forEach((item) => {
    app.component(item.name, item)
  });
}

// 用于按需加载
export default {
  versions: '1.0.0',
  install,
  // 和json解析器相关
  getBasicLayout, 
  registerLayout,
  disposeConfig,
  // 组件相关
  KJsonParse,
  KJsonEdit,
  KButton,
  KIcon,
  KInput,
}